// TODO: type properly

export let SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection["Ascending"] = "Ascending";
  SortDirection["Descending"] = "Descending";
  SortDirection["None"] = "None";
  return SortDirection;
}({});

// collection.field.active

// collection.field.active

/**
 * The editorial-workflow `pages` slice. Deliberately not `PagesObject`, which
 * is keyed by collection and describes the entries reducer: this one is a
 * single flat record for the whole workflow.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any